import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ContextService } from '../context.service';
import { ReminderDefSummaryDto, ReminderDefService } from '@savvy/reminders';
import { MatSidenav } from '@angular/material/sidenav';
import { NavChangeService } from '../element/NavChangeService';
import MenuItemTypeEnum = MenuDefinition.MenuItemTypeEnum;
import { MenuDefinition } from '@savvy/view-definition';
import { ContextIdDto } from '@savvy/menu';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-reminder-defs',
  templateUrl: './reminderDefs.component.html'
})
export class ReminderDefsComponent implements OnInit, OnDestroy {

  @ViewChild('reminderDefPanel', { static: true }) reminderDefPanel: MatSidenav;
  reminderDefs: Array<ReminderDefSummaryDto> = [];
  reminderDef: ReminderDefSummaryDto;
  isLoading = false;
  loadError = false;

  zeroState: boolean;
  selected: ReminderDefSummaryDto[] = [];

  columns = [
    { prop: 'name' }
  ];

  contextIdDto: ContextIdDto;
  subscriptions: Subscription[] = [];

  constructor(
    private reminderDefApi: ReminderDefService,
    private navChange: NavChangeService,
    public contextService: ContextService) {
  }

  ngOnInit() {
    this.subscriptions.push(this.contextService.contextIdDto$.subscribe(data => {
      if (data) {
        this.contextIdDto = data;
        this.navChange.add(MenuItemTypeEnum.Reminders);
        this.loadReminderDefs();
      }
    }));
  }

  ngOnDestroy() {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  loadReminderDefs() {
    this.isLoading = true;
    this.loadError = false;
    console.info('[v2 reminders] loading summaries in reminder definitions page');

    this.reminderDefApi.loadSummaries().subscribe({
      next: reminderDefs => {
        this.reminderDefs = reminderDefs;
        this.isLoading = false;
        console.info('[v2 reminders] summaries loaded in reminder definitions page', {
          reminderDefinitionCount: reminderDefs.length,
        });
      },
      error: error => {
        this.reminderDefs = [];
        this.isLoading = false;
        this.loadError = true;
        console.error('[v2 reminders] summaries failed in reminder definitions page', {
          message: error?.message,
        });
      },
    });
  }

  onSelect(event) {
    this.reminderDef = this.selected[0];
    this.reminderDefPanel.open();
  }

  editReminder(reminderDef: ReminderDefSummaryDto) {
    this.reminderDef = reminderDef;
    this.reminderDefPanel.open();
  }

  reminderUpdated() {
    this.reminderDefPanel.close();
    this.loadReminderDefs();
  }

  reminderCancelled() {
    this.reminderDefPanel.close();
  }

  reminderSelected(reminderDef: ReminderDefSummaryDto) {
    this.reminderDef = reminderDef;
    this.reminderDefPanel.open();
  }

}
